module.exports = __webpack_public_path__ + "img/main.ebb5ba5d.png";